/* eslint-disable react/prop-types */
import { useMemo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from "react-table";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import TableCommon from "components/TableCommon";
import { Link } from "react-router-dom";

const DataTable = ({
  checkCreate,
  query,
  table,
  loading,
  setQuery,
  paginationData,
  setPaginationData,
}) => {
  const columns = useMemo(() => table.columns, [table]);
  const data = useMemo(() => table.rows, [table]);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    setPageSize,
    state: { globalFilter },
  } = tableInstance;

  useEffect(() => {
    if (paginationData?.size) {
      setPageSize(paginationData.size);
    }
  }, [paginationData?.size, setPageSize]);

  const [search, setSearch] = useState(globalFilter || "");

  const onSearchChange = useAsyncDebounce((value) => {
    setQuery((prev) => ({ ...prev, searchBy: value }));
  }, 100);

  return (
    <>
      <SoftBox
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="flex-start"
        p={3}
        pb={1}
      >
        <SoftBox display="flex" justifyContent="flex-start" mb={2}>
          {checkCreate && (
            <Link to="/templates/detailed-ledger-owners-capital/create">
              <SoftButton variant="gradient" color="dark" size="small">
                Tạo Sổ Mới
              </SoftButton>
            </Link>
          )}
        </SoftBox>
        <SoftBox>
          <SoftTypography variant="caption" fontWeight="bold" mb={1} display="block">
            Tìm kiếm:
          </SoftTypography>
          <SoftInput
            placeholder="Search..."
            value={search || ""}
            onChange={({ currentTarget }) => {
              const value = currentTarget.value;
              setSearch(value);
              onSearchChange(value);
            }}
          />
        </SoftBox>
      </SoftBox>
      <TableCommon
        loading={loading}
        query={query}
        setQuery={setQuery}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        tableInstance={tableInstance}
        isSorted={false}
        noEndBorder={true}
      />
    </>
  );
};

DataTable.defaultProps = {
  checkCreate: false,
};

DataTable.propTypes = {
  checkCreate: PropTypes.bool,
  query: PropTypes.object,
  table: PropTypes.shape({
    columns: PropTypes.array,
    rows: PropTypes.array,
  }).isRequired,
  loading: PropTypes.bool,
  setQuery: PropTypes.func,
  paginationData: PropTypes.object,
  setPaginationData: PropTypes.func,
};

export default DataTable;
